import React from 'react';
import clsx from 'clsx';

/**
 * Spinner — single, on-brand loading indicator.
 * Sizes: xs, sm, md, lg, xl
 * Tone:  brand (default), neutral, inverse (for dark backgrounds)
 */
const SIZES = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-7 h-7',
    xl: 'w-10 h-10',
};

const TONES = {
    brand:   'text-brand-500',
    neutral: 'text-ink-muted',
    inverse: 'text-white',
};

export function Spinner({ size = 'md', tone = 'brand', className, label = 'טוען...' }) {
    return (
        <span role="status" aria-label={label} className={clsx('inline-flex items-center justify-center', className)}>
            <svg
                className={clsx('animate-spin', SIZES[size] || SIZES.md, TONES[tone] || TONES.brand)}
                fill="none" viewBox="0 0 24 24" aria-hidden="true"
            >
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-90" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <span className="sr-only">{label}</span>
        </span>
    );
}

/**
 * LoadingState — full-section loading placeholder.
 */
export function LoadingState({ label = 'טוען...', size = 'lg', className }) {
    return (
        <div className={clsx('flex flex-col items-center justify-center gap-3 py-12', className)}>
            <Spinner size={size} />
            {label && <p className="text-sm text-ink-muted">{label}</p>}
        </div>
    );
}

export default Spinner;
